"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
require("./_styles.scss");
var _util = require("../../../util");
var _excluded = ["className"];
var BLOCK_CLASS = 'pf-buttons';
var bem = (0, _util.klass)(BLOCK_CLASS);
var PrimaryButton = function PrimaryButton(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Button, Object.assign({
    variant: "primary"
  }, props, {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS, bem('secondary'))
  }));
};
PrimaryButton.propTypes = {
  className: _propTypes.default.string
};
PrimaryButton.defaultProps = {
  className: ''
};
var _default = PrimaryButton;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');